/* global STRIPE_PUBLIC */
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { Button } from 'antd'
import classNames from 'classnames'
import { putPaymentMethod } from '@reducers/paymentMethod/paymentMethodSlice'
import { selectCurrentUserCompanyId } from '@reducers/currentUser/currentUserSelectors'
import styles from './CardForm.module.scss'

const stripePromise = loadStripe(STRIPE_PUBLIC)

const CardFormInner = (props) => {
  const { onSuccess } = props
  const [cardError, setCardError] = useState()
  const companyId = useSelector(selectCurrentUserCompanyId)

  const dispatch = useDispatch()
  const stripe = useStripe()
  const elements = useElements()

  const handleSubmit = async (event) => {
    event.preventDefault()

    const cardElement = elements.getElement(CardElement)

    const response = await stripe.createToken(cardElement)
    if (response.error) {
      setCardError(response.error.message)
    } else if (response.token && response.token.id) {
      const payload = { stripe_cc_ref: response.token.id }
      const paymentMethodResponse = await dispatch(putPaymentMethod({ payload, companyId }))
      if (paymentMethodResponse.payload.error) {
        setCardError(paymentMethodResponse.payload.error)
      } else {
        onSuccess()
      }
    }
  }

  const onCardChange = (e) => {
    if (e.error) {
      setCardError(e.error.message)
    } else {
      setCardError()
    }
  }

  return (
    <div className={styles.cardForm} data-testid="payment-card-form">
      <CardElement
        className={classNames(styles.cardInput, 'ant-input')}
        onChange={onCardChange}
      />
      {cardError && (
        <div role="alert" className="ant-form-item-explain-error">
          {cardError}
        </div>
      )}
      <Button
        className={styles.saveCardButton}
        type="primary"
        onClick={handleSubmit}
        data-testid="payment-save-card-button"
      >
        Save Card
      </Button>
    </div>
  )
}

const CardForm = (props) => {
  const { onSuccess } = props

  return (
    <Elements stripe={stripePromise}>
      <CardFormInner onSuccess={onSuccess} />
    </Elements>
  )
}

CardForm.defaultProps = {
  onSuccess: () => null,
}


export default CardForm
